import { getAuthHeader } from './authHeaderConfig';
import { checkAndLoadPacsSelectorConfig } from './pacsSelectorConfig';
import { getLicenseID } from './licenseUtils';

export const loadExtraAppConfig = (config) => {
  const appConfig = config;

  if (typeof appConfig.LICENSE_TOKEN !== 'string' || !appConfig.LICENSE_TOKEN.trim()) {
    throw new Error('LicenseToken is required to run the application');
  }

  appConfig.licenseID = getLicenseID(appConfig.LICENSE_TOKEN);
  checkAndLoadPacsSelectorConfig(appConfig);
  appConfig.authorizationHeader = getAuthHeader(appConfig); // get an existing configured way to include auth header to DicomWeb calls, with prioritization
  return appConfig;
};
